package app.bloomey.web.core.modal.modals

import androidx.compose.runtime.Composable
import app.bloomey.web.components.widgets.Height
import app.bloomey.web.components.widgets.SiteButton
import app.bloomey.web.components.widgets.SiteButtonDialogVariant
import app.bloomey.web.core.modal.LocalSiteModelController
import app.bloomey.web.core.modal.SiteModal
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.px

class DeleteItemModal(val title: String, val text: String, val onDelete: () -> Unit) : SiteModal {
    override val popOnClickOutside: Boolean
        get() = true

    @Composable
    override fun Content(modifier: Modifier) {
        val sitePalette = ColorMode.current.toSitePalette()
        val controller = LocalSiteModelController.current
        Column(
            modifier = modifier
                .background(sitePalette.background)
                .borderRadius(8.px)
                .padding(leftRight = 24.px, topBottom = 16.px)
        ) {
            SpanText(
                title,
                modifier = Modifier.fontSize(18.px).fontWeight(FontWeight.SemiBold).color(Colors.Red)
            )
            Height(12.px)
            SpanText(text, modifier = Modifier.fontSize(14.px))
            Height(24.px)
            Row(
                modifier = Modifier.gap(12.px).alignSelf(AlignSelf.End)
            ) {
                SiteButton(
                    variant = SiteButtonDialogVariant,
                    onClick = {
                        controller.pop()
                    }) {
                    SpanText("Close")
                }
                SiteButton(
                    variant = SiteButtonDialogVariant,
                    onClick = {
                        controller.pop()
                        onDelete()
                    }) {
                    SpanText("Delete", modifier = Modifier.color(Colors.Red))
                }
            }
        }
    }
}